import * as st from './liveState.module.scss'
import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import * as utilityClasses from '../utilityClasses.module.scss'

export type LiveStateProps = {
  text?: string
  isLive: boolean
}

export const LiveState = ({ text, isLive }: LiveStateProps) => {
  return (isLive && text ?
    <div className={`${st.liveStatus} ${utilityClasses.fullWidth}`}>
      <Badge use={badges.LIVE}> {text} </Badge>
    </div>
    : null)
}